import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckBoxToggleComponent } from './checkbox-toggle.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [CheckBoxToggleComponent],
  exports: [CheckBoxToggleComponent],
})
export class CheckBoxToggleModule {}
